import { call, put, takeLatest } from "@redux-saga/core/effects";
import AdminPrefrenceService from "../../Services/RestApiManager/AdminPrefrencesManager/AdminPrefrencesService";
import { ADMIN_PREFRENCE_ACTION, errorAdminPreference, responseAdminPreference, responseAdminPreferenceList, errorAdminPreferenceList, responseAdminPreferenceById, errorAdminPreferenceById, responseAdminPreferenceEdit, errorAdminPreferenceEdit } from "./AdminPrefrenceActionCreator";

export function* adminPrefrenceRequest(action) {
    try {
      const response = yield call(AdminPrefrenceService.shared.AdminPreferenceRequest, action.data);
      yield put(responseAdminPreference(response));
    } catch (error) {
      yield put(errorAdminPreference(error));
    }
  }
export function* adminPrefrenceListRequest(action) {
   try {
    const response = yield call(AdminPrefrenceService.shared.AdminPreferenceListRequest, action.data);
    yield put(responseAdminPreferenceList(response));
    } catch (error) {
      yield put(errorAdminPreferenceList(error));
    }}

export  function* adminPrefrenceByIdRequest(action){
  try {
    const response = yield call(AdminPrefrenceService.shared.AdminPreferenceByIdRequest, action.data);  
    yield put(responseAdminPreferenceById(response));
  } catch (error) {
      yield put(errorAdminPreferenceById(error));
      }
}
export function * editAdminPreference(action){
  try{
    const response = yield call (AdminPrefrenceService.shared.EditAdminPreference, action.data)
    yield put(responseAdminPreferenceEdit(response));
  } catch (error){
    yield put(errorAdminPreferenceEdit(error))
  }
}




export function* AdminPrefrenceWatcherSaga() {
  yield takeLatest(ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE, adminPrefrenceRequest);
  yield takeLatest(ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE_LIST, adminPrefrenceListRequest);
  yield takeLatest(ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE_BY_ID, adminPrefrenceByIdRequest);
  yield takeLatest(ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFERENCE_EDIT_STATE,editAdminPreference);
}   
   